export default {
  H: {
    blacked_out: true,
    offsets: {
      tournaments_panel: {
        top: 0,
        left: -1430,
      }
    }
  },
  V: {
    blacked_out: true,
    offsets: {
      tournaments_panel: {
        top: 1016,
        left: -554,
      }
    }
  }
}
